import React, { useState, useEffect } from "react";
import "./Experience.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { Divider, Space, Tag } from "antd";

export default function Experience() {
  const data = [
    {
      key: 1,
      img: "https://media.licdn.com/dms/image/D5622AQHoPniEh1fp9Q/feedshare-shrink_2048_1536/0/1686764029882?e=1694044800&v=beta&t=5nZ6CDwcii1A5ly86S4ud6zyH9yAM80XRNuhYiIKXs8",
      name: "Cosmic Technologies",
      pos: "SDE Intern",
    },
    {
      key: 2,
      img: "https://upload.wikimedia.org/wikipedia/en/6/68/Defence_Research_and_Development_Organisation_Logo.png",
      name: "INMAS (DRDO)",
      pos: "R&D Intern",
    },
    {
      key: 3,
      img: "https://images.crunchbase.com/image/upload/c_lpad,h_170,w_170,f_auto,b_white,q_auto:eco,dpr_1/mdrclcdkv0wvcqtfb8fw",
      name: "CrossTower India",
      pos: "SDE Intern",
    },
    {
      key: 4,
      img: "https://ineptstudio.com/images/logo.png",
      name: "Inept Studio",
      pos: "Full Stack Developer",
    },
  ];

  return (
    <div className="exp">
      <h1 className="exphead1">Learn.Grow.Excel</h1>
      <h3 className="exphead2">My Internship Experiences</h3>
      <br />
      <VerticalTimeline>
        <VerticalTimelineElement
          style={{ textAlign: "left" }}
          className="vertical-timeline-element--work"
          contentStyle={{ background: "#3b4080", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
          date="June 2023 - July 2023"
          iconStyle={{ background: "#3b4080", color: "#fff" }}
          // icon={<WorkIcon />}
        >
          <Tag color="cyan">JS</Tag>
          <Tag color="magenta">React.js</Tag>
          <Tag color="orange">Node.js</Tag>
          <Tag color="gold">Express.js</Tag>
          <Tag color="green">MongoDB</Tag>
          <Tag color="blue">Jira</Tag>
          <Tag color="purple">Bitbucket</Tag>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h3
                style={{ marginTop: "20px" }}
                className="vertical-timeline-element-title"
              >
                SDE Intern
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Cosmic Technologies
              </h4>
            </div>
            <img
              style={{ width: "10vw", marginTop: "15px", borderRadius: "20px" }}
              src="https://media.licdn.com/dms/image/D5622AQHoPniEh1fp9Q/feedshare-shrink_2048_1536/0/1686764029882?e=1694044800&v=beta&t=5nZ6CDwcii1A5ly86S4ud6zyH9yAM80XRNuhYiIKXs8"
              alt=""
            />
          </div>

          <p>
            As an SDE Intern at Cosmic Technologies, I have gained hands-on
            experience in developing an efficient Ticket Managing Software using
            React.js and Node.js, effectively reducing bugs by 30%.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          style={{ textAlign: "left" }}
          className="vertical-timeline-element--work"
          contentStyle={{ background: "#de5914", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
          date="Dec 2022 - Feb 2023"
          iconStyle={{ background: "#de5914", color: "#fff" }}
          // icon={<WorkIcon />}
        >
          <Tag color="magenta">Algorithms</Tag>
          <Tag color="orange">Machine Learning</Tag>
          <Tag color="gold">Preprocessing</Tag>
          <Tag color="green">Data</Tag>
          <Tag color="blue">EEG</Tag>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h3
                style={{ marginTop: "20px" }}
                className="vertical-timeline-element-title"
              >
                R&D Intern
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                INMAS (DRDO)
              </h4>
            </div>
            <img
              style={{
                width: "4vw",
                height: "8vh",
                marginTop: "15px",
                borderRadius: "20px",
              }}
              src="https://upload.wikimedia.org/wikipedia/en/6/68/Defence_Research_and_Development_Organisation_Logo.png"
              alt=""
            />
          </div>
          <p>
            During my R&D Internship at INMAS (DRDO), I successfully implemented
            Machine Learning models for motor imagery classification, achieving
            a 5% increase in accuracy through data preprocessing techniques.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          style={{ textAlign: "left" }}
          className="vertical-timeline-element--work"
          contentStyle={{ background: "#00589d", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
          date="Sept 2022 - Dec 2022"
          iconStyle={{ background: "#00589d", color: "#fff" }}
          // icon={<WorkIcon />}
        >
          <Tag color="purple">Team Lead</Tag>
          <Tag color="cyan">Development</Tag>
          <Tag color="magenta">React.js</Tag>
          <Tag color="orange">Node.js</Tag>
          <Tag color="gold">Express.js</Tag>
          <Tag color="green">MongoDB</Tag>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h3
                style={{ marginTop: "20px" }}
                className="vertical-timeline-element-title"
              >
                SDE Intern
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                CrossTower India
              </h4>
            </div>
            <img
              style={{
                width: "9vw",

                marginTop: "15px",
                borderRadius: "20px",
              }}
              src="https://crosstower.com/wp-content/uploads/2021/09/Crosstower-Logo.png"
              alt=""
            />
          </div>

          <p>
            At CrossTower India, I collaborated with development teams and
            product managers to design client-side and server-side architectures
            using React.js, Node.js, and MongoDB. I also played a key role in
            creating the project schema.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          style={{ textAlign: "left" }}
          className="vertical-timeline-element--work"
          contentStyle={{ background: "#ff254e", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
          date="April 2022 - Sept 2022"
          iconStyle={{ background: "#ff254e", color: "#fff" }}
          // icon={<WorkIcon />}
        >
          <Tag color="blue">HTML</Tag>
          <Tag color="purple">CSS</Tag>
          <Tag color="magenta">React.js</Tag>
          <Tag color="orange">Node.js</Tag>
          <Tag color="gold">Express.js</Tag>
          <Tag color="green">MongoDB</Tag>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h3
                style={{ marginTop: "20px" }}
                className="vertical-timeline-element-title"
              >
                Full Stack Developer Intern
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Inept Studio
              </h4>
            </div>
            <img
              style={{
                width: "5vw",

                marginTop: "15px",
                borderRadius: "20px",
              }}
              src="https://ineptstudio.com/images/logo.png"
              alt=""
            />
          </div>
          <p>
            As a Full Stack Developer Intern at Inept Studio, I designed
            visually appealing front-ends and ensured the smooth functioning of
            databases and applications.
          </p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  );
}
